import React from 'react';
import { OptionalId, RoomDto } from '@/types';
import { RoomInfoEdit } from './RoomInfoEdit';
import { RoomInfoView } from './RoomInfoView';
import { RoomOptionCard } from './RoomOptionsCard';
import theme from './RoomInfo.module.scss';
export interface RoomInfoProps {
    room: OptionalId<RoomDto>;
    editValue: OptionalId<RoomDto> | null;
    onEditValueChange(value: OptionalId<RoomDto> | null): void;
    onSave(newValue: OptionalId<RoomDto>, unitsToLink: number[], unitsToUnlink: number[]): Promise<void>;
    onSaveAndCreateNew(newValue: OptionalId<RoomDto>, unitsToLink: number[], unitsToUnlink: number[]): Promise<void>;
    onDelete?(room: RoomDto): Promise<void>;
    onCopy?(room: RoomDto): Promise<void>;
    onCancelNewRoom?(): void;
    allRooms: RoomDto[] | null;
}

export const RoomInfo: React.FC<RoomInfoProps> = ({ room, onSave, onSaveAndCreateNew, onDelete, onCopy, editValue, onEditValueChange, onCancelNewRoom, allRooms }) => {
    const handleSave = async (unitsToLink: number[], unitsToUnlink: number[]) => {
        if (!editValue) return;
        await onSave(editValue, unitsToLink, unitsToUnlink);
    };

    const handleSaveAndCreateNew = async (unitsToLink: number[], unitsToUnlink: number[]) => {
        if (!editValue) return;
        await onSaveAndCreateNew(editValue, unitsToLink, unitsToUnlink);
    };

    const handleCancel = () => {
        const isNewRoom = editValue && !editValue.id;
        onEditValueChange(null);
        if (isNewRoom) {
            onCancelNewRoom?.();
        }
    };

    if (editValue) {
        return <RoomInfoEdit room={editValue} onChange={onEditValueChange} onSave={handleSave} onSaveAndCreateNew={handleSaveAndCreateNew} onCancel={handleCancel} allRooms={allRooms} />;
    }

    return (
        <div className={theme.roomInfoContainer}>
            <RoomInfoView room={room} onEditClick={() => onEditValueChange(room)} onDeleteClick={onDelete} onCopyClick={onCopy} />
            <RoomOptionCard room={room} />
        </div>
    );
};
